module.exports = __webpack_public_path__ + "q.no2.0dac1a1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/q.no2.jpg
// module id = rZnr
// module chunks = 0